exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.w60[data-v-2e4d0d8c] {\n  width: 60%;\n}\n[data-v-2e4d0d8c] .v-list__tile__content.align-end {\n  white-space: normal;\n  overflow: visible;\n  text-overflow: unset;\n  word-break: break-word;\n}\n[data-v-2e4d0d8c] .v-list__tile__content.align-end {\n  text-align: right;\n}\n[data-v-2e4d0d8c] .v-list__tile:not(.v-list__tile--avatar) {\n  height: initial;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n[data-v-2e4d0d8c] .v-list__tile:hover {\n  background: #eee;\n}\n.v-dialog__content[data-v-2e4d0d8c] {\n  z-index: 1030 !important;\n}\n.no-padding[data-v-2e4d0d8c] {\n  padding: 0 !important;\n}\n", ""]);

// exports
